import React from 'react';
import { replaceInternalOwnerEmails } from '@/utils/internalOwnerLabel';
import './DetailFieldList.css';

export interface DetailFieldItem {
  label: string;
  value: React.ReactNode;
  wrap?: boolean;
  emphasize?: boolean;
  className?: string;
}

export interface DetailFieldListProps extends React.HTMLAttributes<HTMLDivElement> {
  fields: DetailFieldItem[];
}

export const DetailFieldList: React.FC<DetailFieldListProps> = ({
  fields,
  className = '',
  ...props
}) => {
  const classNames = ['ui-detail-field-list', className].filter(Boolean).join(' ');
  const normalizeDisplayValue = (value: React.ReactNode) => (
    typeof value === 'string' ? replaceInternalOwnerEmails(value) : value
  );

  return (
    <div className={classNames} {...props}>
      {fields.map((field, index) => (
        <div
          key={`${field.label}-${index}`}
          className={['ui-detail-field-list__row', field.className].filter(Boolean).join(' ')}
          data-alt={index % 2 === 1 ? 'true' : 'false'}
        >
          <div className="ui-detail-field-list__label">{field.label}</div>
          <div
            className={[
              'ui-detail-field-list__value',
              field.wrap && 'ui-detail-field-list__value--wrap',
              field.emphasize && 'ui-detail-field-list__value--emphasize',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {normalizeDisplayValue(field.value)}
          </div>
        </div>
      ))}
    </div>
  );
};

DetailFieldList.displayName = 'DetailFieldList';
